export const theme = {
  primary: "#CE0A17",
};
